.backdrop {
  position: fixed;
  inset: 0;
  z-index: 40;
  display: grid;
  place-items: center;
  padding: 24px var(--pad);
  background: rgb(0 0 0 / 62%);
  backdrop-filter: blur(6px);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.22s ease, visibility 0.22s;
  touch-action: none;
}

.dialog {
  width: 100%;
  max-width: 340px;
  padding: 28px 20px 20px;
  text-align: center;
  background: var(--hero-bg);
  border: 1px solid var(--card-border);
  border-radius: var(--r-xl);
  box-shadow: var(--shadow-float);
  transform: scale(0.92);
  transition: transform 0.28s cubic-bezier(0.2, 0.9, 0.3, 1.2);
}

.open {
  opacity: 1;
  visibility: visible;
}

.open .dialog {
  transform: scale(1);
}

.badge {
  display: inline-grid;
  place-items: center;
  width: 68px;
  height: 68px;
  color: var(--ok);
  background: var(--ok-wash);
  border: 1px solid rgb(50 215 75 / 30%);
  border-radius: 50%;
}

.open .badge {
  animation: pop 0.42s cubic-bezier(0.2, 0.9, 0.3, 1.3) 0.08s both;
}

.title {
  margin-top: 16px;
  font-size: 21px;
  font-weight: 700;
  color: var(--hero-fg);
}

.text {
  margin: 8px 4px 0;
  font-size: 14px;
  line-height: 1.45;
  color: var(--hero-dim);
}

.actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 22px;
}

@keyframes pop {
  from {
    opacity: 0;
    transform: scale(0.4);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@media (prefers-reduced-motion: reduce) {
  .backdrop,
  .dialog {
    transition: none;
  }

  .open .badge {
    animation: none;
  }
}
